import { useQuery } from '@tanstack/react-query'
import { getSalesforceDealAnos } from '@/lib/apiClients/salesforce'
import { queryKeys } from '@/lib/queryKeys'

export function useSalesforceDealAnos(dealId: number | undefined) {
  return useQuery({
    queryKey: queryKeys.salesforceDealAnos(dealId),
    queryFn: async () => {
      if (dealId === undefined) throw new Error('dealId is required')
      return await getSalesforceDealAnos(dealId)
    },
    enabled: dealId !== undefined,
  })
}
